<div fxLayout="row" fxLayoutAlign="{{ getTextAlign() }}" [matTooltip]="getTooltipMessage()">
  <div class="icon-div" *ngIf="status" [style.background-color]="getIconBackgroundColor()">
    <em class="fas fa-calculator" [class.in-table]="inTable" [class.not-in-table]="!inTable"
    ></em>
  </div>
  <div [class.desc-div-pad]="status" *ngIf="!tooltipMode">
    {{ getStatusDescription() }}
  </div>
</div>
